import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { ProjectSPModel } from "../../models/ProjectSPModel";
import { UpdateBidSubmissionDetailsModel } from "../../models/ProjectModel";
import ProjectSPService from "../../services/ProjectSPService";
import ProjectSPSlice from "../slices/ProjectSPSlice";
import { RootState } from "../store";

export const ProjectSPActions = ProjectSPSlice.actions;

export const fetchParticularProjectSP = (
  ProjectSP_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response: ProjectSPModel =
      await ProjectSPService.getParticularProjectSP(ProjectSP_id);
    dispatch(ProjectSPActions.setParticularProjectSP(response));
  };
};

export const setProjectSPWithInitialValues = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return (dispatch) => {
    dispatch(ProjectSPActions.setProjectSPWithInitialValues());
  };
};

export const setProjectSPBidSubmissionData = (
  data: UpdateBidSubmissionDetailsModel
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(ProjectSPActions.setProjectBidSubmissionData(data));
  };
};

export const setProjectSPIsBidDropped = (
  status: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(ProjectSPActions.setIsBidDropped(status));
  };
};

export const setProjectSPBidPriority = (
  priority: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(ProjectSPActions.setBidPriority(priority));
  };
};
